import React, { useEffect, useState } from "react";
import DefaultLayout from "../../components/Layout/DefaultLayout";
import EnableKycForm from "./EnableKycForm";
import DisableClaimForm from "./DisableClaimForm";
import EnableSolanaFeatureForm from "./EnableSolanaFeatureForm";
import {
  getFlag,
  getForbiddenCountries,
  updateForbiddenCountries,
} from "../../request/config";
import {
  CircularProgress,
  FormControl,
  Grid,
  Switch,
  Tooltip,
} from "@material-ui/core";
import useStyles from "./style";
import ForbiddenCountry from "./ForbiddenCountries";
import StakeForbiddenCountries from "./StakeForbiddenCountries";
import { useForm } from "react-hook-form";
import { alertSuccess } from "../../store/actions/alert";
import { useDispatch } from "react-redux";
import { IS_SHOW_WINNER } from "../../constants";
import EnableShowWinnerParticipantForm from "./EnableShowWinnerParticipantForm";

const Config = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [solnaFeatFlag, setSolanaFeatFlag] = useState(true);
  const [solanaFlag, setSolanaFlag] = useState("");
  const [isOpenEditPopupSolana, setIsOpenEditPopupSolana] =
    useState<boolean>(false);
  const [displaySoalnaLabel, setDisplaySolanaLabel] = useState(true);
  const [localSolanaFlag, setLocalSolanaFlag] = useState(true);
  const [forbiddenCountries, setForbiddenCountries] = useState<any[]>([]);
  const [stakeForbiddenCountries, setStakeForbiddenCountries] = useState<any[]>(
    []
  );

  // Show Winner & Participant
  const [
    isOpenEditPopupShowWinnerParticipant,
    setIsOpenEditPopupShowWinnerParticipant,
  ] = useState<boolean>(false);
  const [
    displayShowWinnerParticipantLabel,
    setDisplayShowWinnerParticipantLabel,
  ] = useState(true);
  const [localShowWinnerParticipantFlag, setLocalShowWinnerParticipantFlag] =
    useState(true);
  const [showWinnerParticipantFlag, setShowWinnerParticipantFlag] =
    useState("");
  const [showWinnerParticipantFeatFlag, setShowWinnerParticipantFeatFlag] =
    useState(true);

  const fetchFlags = async () => {
    try {
      const response = await getFlag();
      const flags = response.data;
      const solanaFlag = flags?.find((flag: any) => flag?.name === "solana");
      const showWinnerParticipantFlag = flags?.find(
        (flag: any) => flag?.name === "hide-winners"
      );
      if (response?.status === 200) {
        setSolanaFlag(solanaFlag);
        setSolanaFeatFlag(solanaFlag.value);
        setShowWinnerParticipantFlag(showWinnerParticipantFlag);
        setShowWinnerParticipantFeatFlag(showWinnerParticipantFlag.value);
      } else {
        console.log("error", response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFlags();
  }, []);

  const handleSolanaSwitchChange = async (event: any) => {
    const { checked } = event?.target;
    const value: any = checked;
    setLocalSolanaFlag(value);
    setIsOpenEditPopupSolana(true);
    setDisplaySolanaLabel(checked);
  };

  const handleShowWinnerParticipantSwitchChange = async (event: any) => {
    const { checked } = event?.target;
    const value: any = checked;
    setLocalShowWinnerParticipantFlag(value);
    setIsOpenEditPopupShowWinnerParticipant(true);
    setDisplayShowWinnerParticipantLabel(checked);
  };

  const {
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      forbidden_countries: forbiddenCountries,
      stake_forbidden_countries: stakeForbiddenCountries,
    },
  });
  const [loadingDeploy, setLoadingDeploy] = useState(false);

  const normalizeCountries = (list: any[]) => {
    return (list || []).map((c) =>
      typeof c === "string" ? c : c.code ? c.code : c.country
    );
  };

  const [forbiddenCountriesId, setForbiddenCountriesId] = useState<any[]>([]);
  const [stakeForbiddenCountriesId, setStakeForbiddenCountriesId] = useState<
    any[]
  >([]);

  const getForbiddenCountriesList = async () => {
    try {
      const response = await getForbiddenCountries();
      const hard = response.data.find(
        (item: any) => item.name === "Hard-Restricted-Countries"
      );
      setForbiddenCountriesId(hard?.id);
      const stake = response.data.find(
        (item: any) => item.name === "Stake-Restricted-Countries"
      );
      setForbiddenCountries(normalizeCountries(hard?.value || []));
      setStakeForbiddenCountries(normalizeCountries(stake?.value || []));
      setStakeForbiddenCountriesId(stake?.id);
    } catch (error) {
      console.error("Error fetching countries", error);
    }
  };

  useEffect(() => {
    getForbiddenCountriesList();
  }, []);

  const updateAllForbiddenCountries = async (data: any) => {
    setLoadingDeploy(true);
    try {
      const [res1, res2] = await Promise.all([
        updateForbiddenCountries(
          { value: data?.forbidden_countries },
          forbiddenCountriesId
        ),
        updateForbiddenCountries(
          { value: data?.stake_forbidden_countries },
          stakeForbiddenCountriesId
        ),
      ]);
      if (res1.status === 200 && res2.status === 200) {
        dispatch(alertSuccess("Forbidden countries updated successfully"));
      }
      window.location.reload();
    } catch (error) {
      console.error("Update failed", error);
    } finally {
      setLoadingDeploy(false);
    }
  };
  return (
    <DefaultLayout>
      <div>
        <EnableKycForm />
        <DisableClaimForm />
        <EnableSolanaFeatureForm
          fetchFlags={fetchFlags}
          solanaFlag={solanaFlag}
          isOpenEditPopupSolana={isOpenEditPopupSolana}
          setIsOpenEditPopupSolana={setIsOpenEditPopupSolana}
          solnaFeatFlag={solnaFeatFlag}
          setSolanaFeatFlag={setSolanaFeatFlag}
          displaySoalnaLabel={displaySoalnaLabel}
          localSolanaFlag={localSolanaFlag}
        />
        <EnableShowWinnerParticipantForm
          fetchFlags={fetchFlags}
          showWinnerParticipantFlag={showWinnerParticipantFlag}
          showWinnerParticipantFeatFlag={showWinnerParticipantFeatFlag}
          isOpenEditPopupShowWinnerParticipant={
            isOpenEditPopupShowWinnerParticipant
          }
          setIsOpenEditPopupShowWinnerParticipant={
            setIsOpenEditPopupShowWinnerParticipant
          }
          displayShowWinnerParticipantLabel={displayShowWinnerParticipantLabel}
          localShowWinnerParticipantFlag={localShowWinnerParticipantFlag}
        />

        <FormControl style={{ flexDirection: "row", alignItems: "center" }}>
          <Tooltip
            title={
              <p>
                This toggle when turned on will show Solana pools on userside
                and when off users will not see Solana pools or anything linked
                to Solana pools like phantom wallet.
              </p>
            }
          >
            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <Switch
                onChange={(e) => handleSolanaSwitchChange(e)}
                checked={solnaFeatFlag ? true : false}
              />
              <h4
                style={{
                  marginRight: "10px",
                  marginTop: "5px",
                  fontSize: "14px",
                }}
              >
                Enable Solana Feature
              </h4>
            </span>
          </Tooltip>
        </FormControl>

        {IS_SHOW_WINNER && (
          <FormControl style={{ flexDirection: "row", alignItems: "center" }}>
            <Tooltip
              title={
                <p>
                  This toggle when turned on will show winner and participant in
                  IDO pools.
                </p>
              }
            >
              <span
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <Switch
                  onChange={(e) => handleShowWinnerParticipantSwitchChange(e)}
                  checked={showWinnerParticipantFeatFlag ? true : false}
                />
                <h4
                  style={{
                    marginRight: "10px",
                    marginTop: "5px",
                    fontSize: "14px",
                  }}
                >
                  Enable Winners and Participants
                </h4>
              </span>
            </Tooltip>
          </FormControl>
        )}
      </div>

      <Grid container spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12} className={classes.exchangeRate}>
          <label className={classes.exchangeRateTitle}>Legal Compliance</label>
          <ForbiddenCountry
            setValue={setValue}
            errors={errors}
            control={control}
            watch={watch}
            poolDetail={{ forbidden_countries: forbiddenCountries }}
          />

          <StakeForbiddenCountries
            setValue={setValue}
            errors={errors}
            control={control}
            watch={watch}
            poolDetail={{ stake_forbidden_countries: stakeForbiddenCountries }}
          />
          <button
            className={classes.formButtonDeploy}
            onClick={handleSubmit(updateAllForbiddenCountries)}
          >
            {loadingDeploy ? <CircularProgress size={25} /> : "Update"}
          </button>
        </Grid>
      </Grid>
    </DefaultLayout>
  );
};

export default Config;
